export default "__VITE_ASSET__9b1b57b4__"